import { injectGlobal } from 'styled-components';
import theme from '../../theme';

const Styles = injectGlobal`
  /**
    @deprecated
   */

  .gray-bg{
    background:${theme.webGray};
  }
  .white-bg{
    background:${theme.whiteColor};
  }
  .rounded{
    border-radius:9px !important;
    box-shadow: 0px 0px 11px 2px rgba(204, 204, 204, 0.21);
  }
  .rounded-bottom{
    border-radius:0px 0px 9px 9px !important;
  }
  .rounded-top{
    border-radius:9px 9px 0px 0px !important;
  }
  .img-grayscale{
    filter: grayscale(100%);
  }
  .ellipsis{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
  .text-center{
    text-align:center;
  }
  .text-right{
    text-align:right;
  }
  .text-left{
    text-align:left;
  }
  .noborderbottom{
    border-bottom:none !important;
  }
  .font-12{
    font-size:12px !important;
  }
  .font-14{
    font-size:14px !important;
  }
  .font-16{
    font-size:16px !important;
  }
  .font-18{
    font-size:18px !important;
  }
  .font-20{
    font-size:20px !important;
  }
  .font-22{
    font-size:22px !important;
  }
  .font-24{
    font-size:24px !important;
  }
  .font-26{
    font-size:26px !important;
  }
  .font-28{
    font-size:28px !important;
  }
  .font-30{
    font-size:30px !important;
  }

  /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Margin Start <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
  .nomargin{
    margin:0px !important;
  }
  .nomargin-left{
    margin-left:0px !important;
  }
  .nomargin-right{
    margin-right:0px !important;
  }
  .nomargin-top{
    margin-top:0px !important;
  }
  .nomargin-bottom{
    margin-bottom:0px !important;
  }
  .margin-1{
    margin:10px !important;
  }
  .margin-2{
    margin:20px !important;
  }
  .margin-3{
    margin:30px !important;
  }
  .margin-4{
    margin:40px !important;
  }
  .margin-5{
    margin:50px !important;
  }
  .margin-6{
    margin:60px !important;
  }
  .margin-7{
    margin:70px !important;
  }
  .margin-8{
    margin:80px !important;
  }
  .margin-9{
    margin:90px !important;
  }
  .margin-10{
    margin:100px !important;
  }

  .margin-l-1{
    margin-left:10px !important;
  }
  .margin-l-2{
    margin-left:20px !important;
  }
  .margin-l-3{
    margin-left:30px !important;
  }
  .margin-l-4{
    margin-left:40px !important;
  }
  .margin-l-5{
    margin-left:50px !important;
  }
  .margin-l-6{
    margin-left:60px !important;
  }
  .margin-l-7{
    margin-left:70px !important;
  }
  .margin-l-8{
    margin-left:80px !important;
  }
  .margin-l-9{
    margin-left:90px !important;
  }
  .margin-l-10{
    margin-left:100px !important;
  }
  .margin-l-35{
    margin-left:350px !important;
  }

  .margin-r-1{
    margin-right:10px !important;
  }
  .margin-r-2{
    margin-right:20px !important;
  }
  .margin-r-3{
    margin-right:30px !important;
  }
  .margin-r-4{
    margin-right:40px !important;
  }
  .margin-r-5{
    margin-right:50px !important;
  }
  .margin-r-6{
    margin-right:60px !important;
  }
  .margin-r-7{
    margin-right:70px !important;
  }
  .margin-r-8{
    margin-right:80px !important;
  }
  .margin-r-9{
    margin-right:90px !important;
  }
  .margin-r-10{
    margin-right:100px !important;
  }

  .margin-t-0-5{
    margin-top: 5px !important;
  }
  .margin-t-1{
    margin-top:10px !important;
  }
  .margin-t-2{
    margin-top:20px !important;
  }
  .margin-t-3{
    margin-top:30px !important;
  }
  .margin-t-4{
    margin-top:40px !important;
  }
  .margin-t-5{
    margin-top:50px !important;
  }
  .margin-t-6{
    margin-top:60px !important;
  }
  .margin-t-7{
    margin-top:70px !important;
  }
  .margin-t-8{
    margin-top:80px !important;
  }
  .margin-t-9{
    margin-top:90px !important;
  }
  .margin-t-100{
    margin-top:100px !important;
  }

  .margin-b-1{
    margin-bottom:10px !important;
  }
  .margin-b-2{
    margin-bottom:20px !important;
  }
  .margin-b-3{
    margin-bottom:30px !important;
  }
  .margin-b-4{
    margin-bottom:40px !important;
  }
  .margin-b-5{
    margin-bottom:50px !important;
  }
  .margin-b-6{
    margin-bottom:60px !important;
  }
  .margin-b-7{
    margin-bottom:70px !important;
  }
  .margin-b-8{
    margin-bottom:80px !important;
  }
  .margin-b-9{
    margin-bottom:90px !important;
  }
  .margin-b-10{
    margin-bottom:100px !important;
  }
  /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Margin ends <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

  /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Padding ends <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

  .nopadding{
    padding:0px !important;
  }
  .nopadding-left{
    padding-left:0px !important;
  }
  .nopadding-right{
    padding-right:0px !important;
  }
  .nopadding-top{
    padding-top:0px !important;
  }
  .nopadding-bottom{
    padding-bottom:0px !important;
  }
  .padding-1{
    padding:10px !important;
  }
  .padding-2{
    padding:20px !important;
  }
  .padding-3{
    padding:30px !important;
  }
  .padding-4{
    padding:40px !important;
  }
  .padding-5{
    padding:50px !important;
  }
  .padding-6{
    padding:60px !important;
  }
  .padding-7{
    padding:70px !important;
  }
  .padding-8{
    padding:80px !important;
  }
  .padding-9{
    padding:90px !important;
  }
  .padding-10{
    padding:100px !important;
  }

  .padding-tb-1{
    padding:10px 0px !important;
  }
  .padding-tb-2{
    padding:20px 0px !important;
  }
  .padding-tb-3{
    padding:30px 0px !important;
  }
  .padding-tb-4{
    padding:40px 0px !important;
  }
  .padding-tb-5{
    padding:50px 0px !important;
  }
  .padding-tb-6{
    padding:60px 0px !important;
  }
  .padding-tb-7{
    padding:70px 0px !important;
  }
  .padding-tb-8{
    padding:80px 0px !important;
  }
  .padding-tb-9{
    padding:90px 0px !important;
  }
  .padding-tb-10{
    padding:100px 0px !important;
  }

  .padding-l-1{
    padding-left:10px !important;
  }
  .padding-l-2{
    padding-left:20px !important;
  }
  .padding-l-3{
    padding-left:30px !important;
  }
  .padding-l-4{
    padding-left:40px !important;
  }
  .padding-l-5{
    padding-left:50px !important;
  }
  .padding-l-6{
    padding-left:60px !important;
  }
  .padding-l-7{
    padding-left:70px !important;
  }
  .padding-l-8{
    padding-left:80px !important;
  }
  .padding-l-9{
    padding-left:90px !important;
  }
  .padding-l-10{
    padding-left:100px !important;
  }

  .padding-r-1{
    padding-right:10px !important;
  }
  .padding-r-2{
    padding-right:20px !important;
  }
  .padding-r-3{
    padding-right:30px !important;
  }
  .padding-r-4{
    padding-right:40px !important;
  }
  .padding-r-5{
    padding-right:50px !important;
  }
  .padding-r-6{
    padding-right:60px !important;
  }
  .padding-r-7{
    padding-right:70px !important;
  }
  .padding-r-8{
    padding-right:80px !important;
  }
  .padding-r-9{
    padding-right:90px !important;
  }
  .padding-r-10{
    padding-right:100px !important;
  }

  .padding-t-1{
    padding-top:10px !important;
  }
  .padding-t-2{
    padding-top:20px !important;
  }
  .padding-t-3{
    padding-top:30px !important;
  }
  .padding-t-4{
    padding-top:40px !important;
  }
  .padding-t-5{
    padding-top:50px !important;
  }
  .padding-t-6{
    padding-top:60px !important;
  }
  .padding-t-7{
    padding-top:70px !important;
  }
  .padding-t-8{
    padding-top:80px !important;
  }
  .padding-t-9{
    padding-top:90px !important;
  }
  .padding-t-100{
    padding-top:100px !important;
  }

  .padding-b-1{
    padding-bottom:10px !important;
  }
  .padding-b-2{
    padding-bottom:20px !important;
  }
  .padding-b-3{
    padding-bottom:30px !important;
  }
  .padding-b-4{
    padding-bottom:40px !important;
  }
  .padding-b-5{
    padding-bottom:50px !important;
  }
  .padding-b-6{
    padding-bottom:60px !important;
  }
  .padding-b-7{
    padding-bottom:70px !important;
  }
  .padding-b-8{
    padding-bottom:80px !important;
  }
  .padding-b-9{
    padding-bottom:90px !important;
  }
  .padding-b-10{
    padding-bottom:100px !important;
  }
  /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Padding ends <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
  .cursor{
    cursor:pointer;
  }
  .cursor-not-allowed {
    cursor: not-allowed !important;
  }
  .text-red{
    color: ${theme.primaryColor};
  }
  .text-black{
    color: ${theme.blackColor};
  }
  .bgwhite{
    background-color:${theme.whiteColor}!important; /** @todo move to theme */
  }

  .width-1{
    width:10%;
  }
  .width-2{
    width:20%;
  }
  .width-3{
    width:30%;
  }
  .width-4{
    width:40%;
  }
  .width-5{
    width:50%;
  }
  .width-6{
    width:60%;
  }
  .width-7{
    width:70%;
  }
  .width-8{
    width:80%;
  }
  .width-9{
    width:90%;
  }
  .width-100{
    width:100%;
  }
  .email{
    word-break: break-all;
  }
  .border-right-gray{
    border-right:${theme.grayColor} solid 1px;
  }
  .border-left-gray{
    border-left:${theme.grayColor} solid 1px;
  }
  .flex{
    display: flex;
  }
  .flex-start{
    align-items: flex-start;
  }
  .ant-select-selection:hover {
    border-color: #949494;
    border-right-width: 1px !important;
  }
  .ant-input:hover {
    border-color: #949494;
    border-right-width: 1px !important;
  }
  .ant-input-search:hover{
    border-color: #949494;
  }
  .ant-input:focus{
    border-color: #949494;
    box-shadow:0;
  }
  .ant-btn:hover, .ant-btn:focus {
    color: ${(props) => props.theme.hotRed};
    border-color: ${(props) => props.theme.hotRed};
  }

  .ant-pagination-item:focus, .ant-pagination-item:hover {
    border-color: ${(props) => props.theme.hotRed};
  }
  .ant-pagination-item:focus a, .ant-pagination-item:hover a {
    color: ${(props) => props.theme.hotRed};
}
.ant-pagination-item-active {
    border-color: ${(props) => props.theme.hotRed};
    a{
      color: ${(props) => props.theme.hotRed};
    }
}
  .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active {
    -webkit-box-shadow: 0;
    box-shadow: 0;
    border-color: #949494;
}
.dropbox{
  .ant-upload.ant-upload-drag{
    border: 1px dashed ${theme.grayColor};
    &:hover{
      border: 1px dashed ${theme.primaryColor};
    }
    .anticon{
      color: ${theme.primaryColor} !important;
    }
  }
}
.pro-steps{
  .ant-steps-item-process{
    .ant-steps-item-icon{
    background: ${theme.primaryColor};
    border-color: ${theme.lightRed};
    }
  }
  
}
.ant-switch-checked{
  background-color: ${theme.greenColor};
}
.ant-form-item-label{
  label{
  color: ${theme.shuttleGrey};
  }
}
.ant-input{
  color: ${theme.inputGray};
  font-weight:400;
}
.ant-select-selection-selected-value{
  color: ${theme.inputGray};
  font-weight:400;
}
.ant-card{
    &.noborder{
        border:0 !important;
    }
}
.ant-card{
    &.noshadow{
        box-shadow:none !important;
    }
}
.card-padding-0{
  .ant-card-body{
    padding:0px;
  }
}
.card-height-100{
  .ant-card-body{
    overflow-x: hidden;
    height: 80vh;
  }
}
.card-padding-0{
  .ant-card-body{
    padding:0px;
  }
}
.card-padding-20{
  .ant-card-body{
    padding:20px;
  }
}

.ant-btn-primary{
  background:${theme.primaryColor};
  color:${theme.whiteColor};
  text-transform:uppercase;
  border: none;
  font-size: 14px;
  padding: 12px 24px;
  line-height: normal;
  height: auto;
  display:inline-block;
  &:hover, &:active, &:focus{
    background-color: ${theme.hotRed};
    border-color: ${theme.hotRed};
  }
}


.ant-btn-link{
  color:${theme.primaryColor};
  display:inline-block;
  &:hover{
  }
}

input{
  background: ${theme.lightWhite};
        border: 1px solid #DEDEDF;
        border-radius: 4px;
        padding: 15px;
        height: auto;
}
.ant-select-dropdown{
  z-index: 10000
}
.height-auto{
  height: auto;
}
.custom-rangepicker{
  .ant-calendar-picker-input{
    height: 40px;
    .ant-calendar-range-picker-separator{
      vertical-align: initial;
    }
  }
}
.custom-breadcrumb{
  .crumb-link{
    &:hover{
      color: ${theme.primaryColor};
    }
  }
  .ant-breadcrumb-separator{
    color: ${theme.primaryColor};
    font-weight: 600;
  }
}
.custom-tabs{
  .ant-tabs-bar{
    border-bottom: none;
    .ant-tabs-nav-container{
      height: auto !important;
    }
    .ant-tabs-nav-wrap{
      .ant-tabs-nav-scroll{
        text-align: center;
        .ant-tabs-nav{
          background: #F1F2F7;
          border-radius: 10px;
          padding: 5px;
          .ant-tabs-tab{
            background: transparent;
            border: none;
            font-weight: bold;
            color: #000000;
            height: auto;
            padding: 12px 10px;
            line-height: normal;
            width: 250px;
            &.ant-tabs-tab-active{
              background: #ED3B41;
              color: #ffffff;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
}
.info-color{
  color: ${theme.infoColor};
}.text-lightgray{
  color: ${theme.grayColor}80 !important;
.info-red-color{
  color: ${theme.hotRed};
}
.info-red-color{
  color: ${theme.hotRed};
}
.info-red-color{
  color: ${theme.hotRed};
}
.text-lightgray{
  color: ${theme.grayColor}80 !important;
}
`;

export default Styles;



// WEBPACK FOOTER //
// client/containers/Root/cssStyles.js